import React, { Component } from "react";
import soon from "../assets/img/trial.png";
import { Typography, Button } from "@material-ui/core";
// import { sendCustomAnalytics } from "../helper/analyticsHelper";
import Snackbar from "@material-ui/core/Snackbar";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import classNames from 'classnames';


class Trial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      message: "",
      variant: ''
    };
  }

  upgradeClicked = async routeName => {
    // let result = await sendCustomAnalytics("clicked", `upgrade`, {
    //   root: routeName
    // });
    // if (result === true) {
    //   this.setState({ open: true, message: "Request Sent", variant: 'success-snackbar' });
    // } else {
    //   this.setState({ open: true, message: "Error on Request", variant: 'error-snackbar' });
    // }
  };

  handleClose = (event, reason) => {
    // if (reason === "clickaway") {
    //   return;
    // }

    // this.setState({ open: false });
  };

  render() {
    let { routeName } = this.props;
    let { open, message, variant } = this.state;
    return (
      <div
        style={{
          textAlign: "center",
          padding: "20px",
          maxWidth: "600px",
          margin: "auto"
        }}
      >
        <img src={soon} style={{ maxWidth: "430px" , width: '100%'}} />
        <Typography variant="h2" style={{ color: '#6D6D6D' }}>
          Trial Mode
        </Typography>
        <Typography style={{ marginTop: "25px", fontSize: "19px", color: '#6D6D6D' }}>
          Please upgrade to benefit from additional features
        </Typography>
        <Button
          onClick={() => this.upgradeClicked(routeName)}
          variant="contained"
          style={{ marginTop: '30px', outline: 'none', background: '#00CD6B', 
          boxShadow: '4px 4px 18px 1px rgba(0, 205, 107, 0.35)', 
          borderRadius: '3px',  
          width: '300px',  
          color: '#FFFFFF', padding: '10px' }}
        >
          Upgrade
        </Button>

        <Snackbar
        className={variant}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right"
          }}
          open={open}
          autoHideDuration={6000}
          onClose={this.handleClose}
          message={message}
          action={
            <React.Fragment>
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={this.handleClose}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </React.Fragment>
          }
        />
      </div>
    );
  }
}

export default Trial;



// WEBPACK FOOTER //
// ./src/components/Trial.js